<template lang="pug">
VContainer.qmodii-cont.qmodii-marketscreener(fluid, grid-list-md)
  VDialog(v-model="gLoading", max-width="300px" style='z-index:20001;', content-class="qmodii-loader-dialog") 
    VCard(color="primary" dark)
      VCardText
        | Loading...
        VProgressLinear(:indeterminate="true", color="white" class="mb-0")
  VDialog(v-model="modal2", v-if="modal2" max-width="700px" style='z-index:20001;' :fullscreen="$vuetify.breakpoint.xsOnly")
    component(:is="modaltype", @finished="closemodals" :activeTab="opentab")
  VDialog(v-model="symbollookup", v-if="symbollookup", max-width="600px")
    component(
      is="SymbolLookup"
      :token="authTOken3",
      @addSymbolLookup="addSymbolLookup",
      @addSymbolLookup_close="addSymbolLookup_close"
      :customIndcies="PropIndcies",
    )
  BaseWrapper.qmod-MarketScreener(v-if="showtable")
    span(slot="ComponentTitle") {{ $t('screener.marketscreener') }}
    div(slot="toolTitleButtons")
      VBtn(color="primary"): i.fa.qmod-icon.fa-spinner
    BaseBlock
      .qmod-flex.qmod-screener
        .qmod-fixed-fixedFilters(v-if="gAvailableCountrys")
          span.qmod-screener-type(v-if="this.screenerTypes.length > 1")
            VSelect(:items="screenerTypes" attach v-model="selectedScreener" label="Screener" dense @input="changeScreener()")
          span.qmod-screener-country(v-for="(filter, idx) in gAvailableCountrys")
            VSelect(
              :items="filter.dropdown.list",
              @input="changeCountry(filter.dropdown.selected)",
              item-text="label",
              item-value="type",
              item-avatar="avatar",
              attach,
              v-model="filter.dropdown.selected",
              :label="filter.name",
              dense
            )
              template(slot="selection", slot-scope="{ item, index }")
                img.qmod-flag(:src="item.avatar", :alt="item.label", width="25")
                span {{ item.label }}
          span.qmod-side-btns
            VBtn(color="primary", small, flat, @click="openmodal('preset')" v-if="selectedScreener == 'equity'") {{ $t('screener.presetscreener') }}
            VBtn(
              color="primary",
              small,
              v-if="isLoggedIn",
              flat,
              @click="openmodal('saved', 0)"
            ) {{$t('screener.savedscreens')}}
            VBtn(
              color="primary",
              small,
              v-if="isLoggedIn",
              @click="openmodal('saved', 1)"
            ) {{$t('screener.save')}}
        .qmoo-critera-btns
          span.qmod-criter-collpase
            VBtn(
              v-if="showCritera",
              color="primary",
              small,
              flat,
              @click="showCritera = !showCritera"
            )
              i.material-icons expand_more
              | {{$t('screener.hidecritera')}}
            VBtn(
              v-else,
              color="primary",
              small,
              flat,
              @click="showCritera = !showCritera"
            )
              i.material-icons chevron_right
              | {{$t('screener.showcritera')}}
              | {{ gActiveCriteria.length > 0 ? `(${gActiveCriteria.length} Active filters)` : '' }}
        .qmod-critera-group(v-if="showCritera")
          .qmod-parencriteria
            .qmod-mobile-critera
              span.addcriter
                h3 Add a criteria
              div
                select.qmod-mobile-select(v-model="mobileSelected")
                  option(disabled value="default" selected="true") -- Select a criteria --
                  optgroup(
                    v-for="Criteria in gEquityCriteria",
                    :label="Criteria.name"
                  )
                    option(
                      v-for="subCriteria in Criteria.fixedFilters",
                      :value="subCriteria"
                    ) {{ subCriteria.name }}
                    option(
                      v-for="subCriteria in Criteria.rangedFilters",
                      :value="subCriteria"
                    ) {{ subCriteria.name }}
              .qmod-cri-buttons-mobile
                VBtn(color="primary", block, @click="addSignleFilter()") {{ $t('screener.addfilter') }}
            div.qmod-autocomplete
              VAutocomplete(ref='symbolautocomplete' @change='doSearchLookup' @blur='autoCompleteBlur' return-object :items="gSearchCritera" item-text="name" :label="$t('screener.searchforcriteria')" attach flat prepend-icon="search")
            .qmod-flex.qmod-fxrow.qmod-criteria-pickers
              ul.qmod-ul.qmod-criteria-ul.qmod-criteria-pick.qmod-main-critera
                li.qmod-li.qmod-li.qmod-criteria-li(
                  v-if="gEquityCriteria.length"
                  v-for="(Criteria, parentindex) in gEquityCriteria",
                  @click="setSubCriteria(parentindex)",
                  :class="[subScreenerCriteria == parentindex ? 'qmod-active-li' : '']",
                  :key="Criteria.name + parentindex"
                )
                  i.material-icons {{ subScreenerCriteria == parentindex ? 'folder_open' : 'folder' }}
                  span.qmod-criname {{ Criteria.name }} ({{ Criteria.rangedFilters.length + Criteria.fixedFilters.length }})
              ul.qmod-ul.qmod-criteria-ul.qmod-criteria-pick.qmod-sub-critera(
                v-if="subScreenerCriteria !== false && gEquityCriteria[subScreenerCriteria]"
              )
                li.qmod-li.qmod-criteria-li.qmod-subcritera-li(
                  v-if="gEquityCriteria[subScreenerCriteria]"
                  v-for="(subCriteria1, idx) in gEquityCriteria[subScreenerCriteria].fixedFilters",
                  :key="subCriteria1.id + idx"
                  @click.self="checkboxClick"
                  :id="subCriteria1.id + gEquityCriteria[subScreenerCriteria].id"
                )
                  span.qmod-criname
                    VCheckbox.qmod-crcheckbox(
                      :key="gAvailableCountrys[0].dropdown.selected + subCriteria1.id + gEquityCriteria[subScreenerCriteria].id",
                      :label="subCriteria1.name",
                      v-model="selectedCritera",
                      :value="subCriteria1",
                    @change="changeSelected(subCriteria1)"
                    )
                  .qmod-crdesc {{ subCriteria1.description }}
                li.qmod-li.qmod-criteria-li.qmod-subcritera-li(
                  v-for="(subCriteria, idx) in gEquityCriteria[subScreenerCriteria].rangedFilters",
                  :key="subCriteria.id + idx"
                  @click.self="checkboxClick"
                    :id="subCriteria.id + gEquityCriteria[subScreenerCriteria].id"
                )
                  span.qmod-criname
                    VCheckbox.qmod-crcheckbox(
                      :key="gAvailableCountrys[0].dropdown.selected + subCriteria.id + gEquityCriteria[subScreenerCriteria].id",
                      :label="subCriteria.name",
                      v-model="selectedCritera",
                      :value="subCriteria"
                      @change="changeSelected(subCriteria)"
                    )
                  .qmod-crdesc {{ subCriteria.description }}
              .qmod-noselectedcritera.qmod-criteria-desc.qmod-criteria-pick(
                v-else
              )
                span {{ $t('screener.nocritera') }}
            .qmod-cri-buttons
              VBtn(
                v-if="gActiveCriteria.length < 1",
                color="primary",
                @click="addFilter()"
              ) {{ $t('screener.addfilter') }}
              VBtn(v-else, color="primary", @click="addFilter()") {{ $t('screener.addfilters') }}
          .qmod-selectedcriteria(v-if="gActiveCriteria.length")
            table.qmod-table.qmod-selected-critera-table
              thead.qmod-thead
                tr.qmod-tr1
                  th {{ $t('screener.critera') }}
                  th.qmod-textr {{ $t('labels.min') }}
                  td.qmod-textr.qmod-criera-range
                  th.qmod-textr {{ $t('labels.max') }}
                  th.qmod-textr {{ $t('labels.matches') }}
                  td.qmod-textr
              tbody.qmod-tbody
                template(v-for="(activeCriteria, idx) in gActiveCriteria")
                  tr.qmod-tr0()
                    td.qmod-td.qmod-criera-title(colspan='5')
                     span.qmod-criera-title {{ activeCriteria.displayname }}
                  tr.qmod-tr1()
                    template(v-if="!activeCriteria.list")
                      td.qmod-td.qmod-criera-title
                        span.qmod-criera-title {{ activeCriteria.displayname }}
                      td.qmod-td.qmod-criera-total.qmod-textr
                        div.qmod-criera-total(v-if="activeCriteria.date")
                          VMenu(
                            ref="datemenu"
                            v-model="datemenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                            max-height="100%"
                          )
                            template(slot="activator")
                              VTextField(
                                :value="formatDate(activeCriteria.minRange)"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                              )
                            VDatePicker(:value="convertDate(activeCriteria.minRange)" @input="setDate($event, activeCriteria, 'minRange', 'datemenu')" no-title)
                        div.qmod-criera-total(v-else)
                          VTextField(
                            :suffix="activeCriteria.percent ? '%' : ''",
                            @blur="convertNumber($event, activeCriteria, 'minRange')",
                            @keydown.enter="convertNumber($event, activeCriteria, 'minRange')",
                            :value="testnumber(activeCriteria.minRange)"
                            :rules="activeCriteria.showErrorMax"
                            :aria-label="`${activeCriteria.displayname} min value`"
                          )
                      td.qmod-td.qmod-criera-range.qmod-textc
                        RangeChart(
                          v-if="activeCriteria.histogram",
                          :activecritera="activeCriteria"
                        )
                      td.qmod-td.qmod-criera-total.qmod-textr
                        div.qmod-criera-total(v-if="activeCriteria.date")
                          VMenu(
                            ref="datemenu2"
                            v-model="datemenu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                            max-height="100%"
                          )
                            template(slot="activator")
                              VTextField(
                                :value="formatDate(activeCriteria.maxRange)"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                              )
                            VDatePicker(:value="convertDate(activeCriteria.maxRange)" @input="setDate($event, activeCriteria, 'maxRange', 'datemenu2')" no-title)
                        div.qmod-criera-total(v-else)
                          VTextField(
                            :suffix="activeCriteria.percent ? '%' : ''",
                            @blur="convertNumber($event, activeCriteria, 'maxRange')",
                            @keydown.enter="convertNumber($event, activeCriteria, 'maxRange')",
                            :value="testnumber(activeCriteria.maxRange)"
                            :rules="activeCriteria.showErrorMax",
                            :aria-label="`${activeCriteria.displayname} max range`"
                          )
                      td.qmod-td.qmod-criera-total.qmod-textr
                        span.qmod-criera-total {{ activeCriteria.rangeSize }}
                      td.qmod-td.qmod-criera-buttons.qmod-textr
                        span.qmod-criera-buttons
                          VBtn(small color="error", icon, @click="delFilter(idx, activeCriteria)"): i.material-icons.md-18 close
                    template(v-else)
                      td.qmod-td.qmod-criera-title
                        span.qmod-criera-title {{ activeCriteria.displayname }}
                      td(:colspan='$vuetify.breakpoint.xsOnly ? 2 : 3')
                        VSelect(
                          v-if="activeCriteria.id == 'low52week' || activeCriteria.id == 'high52week' || activeCriteria.id == 'optionable' || activeCriteria.id == 'primarysymbol' || activeCriteria.id == 'filingcurrent'",
                          :items="activeCriteria.list",
                          @input="selectChange()",
                          item-text="label",
                          item-value="type",
                          attach,
                          fixed=true,
                          v-model="activeCriteria.selected",
                          dense
                        )
                        VSelect(
                          v-else-if="activeCriteria.id == 'topHoldings'"
                          :items="activeCriteria.selected",
                          multiple,
                          chips,
                          deletable-chips,
                          @focus.prevent.stop="addSymbolLookup_open(activeCriteria,$event)",
                          @change="addSymbolLookup_change($event)"
                          @input="addSymbolLookup_input($event)"
                          attach,
                          v-model="activeCriteria.selected",
                          dense,
                          menu-props="disabled"
                          append-icon=""
                          :label="$t('labels.symbol_or_name')"
                        )
                        VSelect.qmodii-dropdownbox(
                          v-else-if="activeCriteria.id == 'exchangeGroups' || activeCriteria.id === 'companyRating' || activeCriteria.id == 'zacksRating' || activeCriteria.id == 'cfraRating' || activeCriteria.id == 'scotiaRating'",
                          :items="activeCriteria.list",
                          multiple,
                          @input="selectChange(activeCriteria)",
                          item-text="label",
                          item-value="type",
                          attach,
                          v-model="activeCriteria.selected",
                          dense,
                        )
                        VSelect(
                          v-else-if="activeCriteria.isFund",
                          :items="activeCriteria.list",
                          multiple,
                          @input="selectChangeFund(activeCriteria)",
                          item-text="label",
                          item-value="type",
                          attach,
                          v-model="activeCriteria.selected",
                          dense,
                          )
                        VTextField(
                          v-else,
                          :items="activeCriteria.list",
                          :aria-label="activeCriteria.displayname",
                          multiple,
                          @focus.prevent.stop="openmodal('sector')",
                          item-text="label",
                          item-aria-label="label",
                          item-value="type",
                          attach,
                          :value="gSectorSelectedLabels",
                          dense,
                          readonly
                        )
                          template(
                            slot="selection",
                            slot-scope="{ item, index }"
                          )
                            span {{ isParentSector(item, index) }}
                      td.qmod-td.qmod-criera-total.qmod-textr
                        span.qmod-criera-total {{ activeCriteria.rangeSize }}
                      td.qmod-td.qmod-criera-buttons.qmod-textr
                        span.qmod-criera-buttons
                          VBtn(small color="error", icon, @click="delFilter(idx, activeCriteria)"): i.material-icons.md-18 close
            .qmod-selectedcriteria-item.qmod-selectedcriteria-btns
              //- BaseButton.qmod-btn-blue(:isLoading="false", :onClick="postCriteria") Search
              span.qmod-table-extras
                span.text-xs-center(v-if="gFullPages > 1")
                  VPagination(
                    v-model="currentPage",
                    :total-visible="5",
                    :length="gFullPages",
                    @input="changePage(page)"
                  )
                .qmod-results-showing(v-if="gResults")
                  span.qmod-table-numberOfElements {{ $t('labels.showing') }}: {{  ((currentPage-1) * propPaginationPerPage) + 1 }} - {{ ( ((currentPage-1) * propPaginationPerPage) + gResults.length) }} {{ $t('labels.of') }} {{ gATotalResults }}
                  span.qmod-table-totalElements {{ $t('labels.limitedresults') }}
        .qmod-screener-showtable(ref="tableWrapper")
          .qmod-screener-results(v-if="gResults.length")
            VTabs(v-model="currentTab" )
              VTab(v-for="ctabItem in gCustomTabItems" :key="ctabItem.label" :href="`#${ctabItem.label}`") {{ctabItem.label}}
              VTab(v-for="tabItem in gTabItems" :key="tabItem.label" :href="`#${tabItem.label}`" @click='tabClicked') {{ $t(`tabs.${tabItem.label}`)}} 
              .v-tabs__div.qmod-export-tab(
                @click="openmodal('custom')"
              )
                i.material-icons table_view
                | {{ $t(`tabs.manage`)}}
              .v-tabs__div.qmod-export-tab(
                @click="exportTableToCSV('screener.csv')"
              )
                i.material-icons import_export
                | {{ $t(`tabs.export`)}}
            VTabsItems(v-model="currentTab" touchless)
              VTabItem(v-if="gCustomTabItems" v-for="customtabItem in gCustomTabItems" :key="customtabItem.label" :value="`${customtabItem.label}`")
                table.qmod-table.qmod-screener-results-table
                  tr
                    th(v-for="header in customtabItem.items" :class="header.class"  @click="sortTable(header)").qmodii-table-th
                      div.qmodii-table-header-wrap(v-if="header.label")
                        span {{ $t(`tableheaders.${[header.label]}`) }}                      
                        i.material-icons.qmodii-table-sort-icons(v-if="gSortTable.by == header.key && gSortTable.direction == 'asc'")  keyboard_arrow_up
                        i.material-icons.qmodii-table-sort-icons(v-else-if="gSortTable.by == header.key && gSortTable.direction == 'desc'" )  keyboard_arrow_down
                        i.material-icons.qmodii-table-sort-icons(v-else)  unfold_more
                  tr(v-for="result in gResults")
                    td(v-for="col in customtabItem.items" :class="col.class" v-html="getColValue(result, col.key, '-', col.format)")
                    
              VTabItem(v-for="tabItem in gTabItems" :key="tabItem.label" :value="`${tabItem.label}`" lazy :transition="false" :reverse-transition="false")
                table.qmod-table.qmod-screener-results-table(:ref="`tableElement-${tabItem.label}`" :id="`qmod-screener-results-table-${tabItem.label}`")
                  tr
                    th(v-if="tabItem.hasChildren").qmodii-child-toggle
                    th(v-for="header in tabItem.table.items" :class="header.class" v-show="header.visible" @click="sortTable(header)").qmodii-table-th
                      div.qmodii-table-header-wrap(v-if="header.label")
                        span.qmodii-table-header {{ $t(`tableheaders.${[header.label]}`) }}
                        i.material-icons.qmodii-table-sort-icons(v-if="gSortTable.by == header.key && gSortTable.direction == 'asc'")  keyboard_arrow_up
                        i.material-icons.qmodii-table-sort-icons(v-else-if="gSortTable.by == header.key && gSortTable.direction == 'desc'" )  keyboard_arrow_down
                        i.material-icons.qmodii-table-sort-icons(v-else)  unfold_more
                    th.qmodii-actions(v-if="propActionMenu.actionMenuHandler") Actions
                  template(v-for="result in gResults")
                    tr(:class="{'qmodii-child-table-open' : result.areChildrenVisible}")
                      td(v-if="tabItem.hasChildren").qmodii-child-toggle
                        VBtn(icon @click="toggleChildRow(result)")
                          i(v-if="result.areChildrenVisible").material-icons.md-18 remove_circle_outline
                          i(v-else).material-icons.md-18 add_circle_outline
                      td(v-for="col in tabItem.table.items" :class="[col.class,'qmodii-td-'+col.key]" v-show="col.visible" v-html="getColValue(result, col.key, '-', col.format)")
                      td.qmodii-actions(v-if="propActionMenu.actionMenuHandler")
                        ActionMenu(@ActionMenuClick="actionMenuHandler" :clickInfo="result" :actionMenu='propActionMenu')
                    tr(v-if="result.areChildrenVisible").qmodii-child-table-tr
                      td( colspan="100%")
                        table.qmodii-child-table
                          tr.qmodii-child-row(v-for="col in tabItem.table.items" v-if="!col.visible")
                            td.qmodii-table-header {{ $t(`tableheaders.${[col.label]}`) }} :
                            td(v-html="getColValue(result, col.key, '-', col.format)")
          span.qmod-no-results(v-else) {{ $t('screener.noresults') }}
</template>
<script>
import {
  VContainer,
  VLayout,
  VFlex,
  VBtn,
  VSelect,
  VTab,
  VTabs,
  VTabsItems,
  VTabItem, 
  VSpacer,
  VDialog,
  VTextField,
  VRangeSlider,
  VPagination,
  VProgressLinear,
  VCheckbox, 
    VAutocomplete,
    VDataTable,
    VMenu,
    VIcon,
    VDatePicker
} from "vuetify/lib";
import { Parser } from "json2csv";
import { mapGetters, mapState } from "vuex";
import state from "./state";
import RangeChart from "../../mini/RangeChart";
import ActionMenu from "../../mini/ActionMenu";
import Screens from "./modals/Screens";
import Sectors from "./modals/Sectors";
import SavedScreens from "./modals/SavedScreens";
import customModal from "./modals/CustomCols";

import SymbolLookup from "../advancedchart/modals/SymbolLookup";

import BaseWrapper from "@LAYOUT/BaseWrapper";
import BaseBlock from "@LAYOUT/BaseBlock";
// import BaseButton from "@LAYOUT/BaseButton";
import BaseDropdown from "@LAYOUT/BaseDropdown";
import axios from "axios";

const useDefaultLoadState = (loadState, sessionState) => {
  if (sessionState !== null) {
    return (loadState && loadState.priority)
  } else {
    return loadState && loadState.priority && (loadState.criteria && Object.keys(loadState.criteria).length > 0);
  }
};

export default {
  name: "MarketScreener",
  props: {
    qSymbol: {
      type: String,
      required: false,
      default: "MSFT",
    },
    forwardURL: {
      type: String,
      required: false,
    },
    symbolforwardURL: {
      type: String,
      required: false,
    },
    propCountry: {
      type: String,
      required: false,
      default: "US",
    },
    propEnabledTypes: {
      type: String,
      required: false,
      default: 'equity,etf',
    },
    propAutoCollapse: {
      type: Boolean,
      required: false,
      default: false,
    },
    propExportAsEvent: {
      type: Boolean,
      required: false,
      default: false,
    },
    propActionMenu: {
      type: Object,
      required: false,
      default() {
        return {
          actionMenuHandler: null,
          tradeEnabled: false,
          addToPortfolioEnabled: false,
          addToWatchlistEnabled: false,
          addToAlertsEnabled: false,
          forwardToDetailedQuoteEnabled: false,
          chartForwardEnabled: false,
          optionChainEnabled: false,
        };
      },
    },
    propPaginationPerPage: {
      type: Number,
      required: false,
      default: 100
    },
    loadState: {
      type: Object,
      required: false,
      default() {
        return {
          criteria: {},
          instrument: 'equity',
          priority: false
        };
      }
    },
    opts: {},
  },
  async created() {
    this.$store.registerModule("MarketScreener", state);

    this.$store.state.MarketScreener.RESULTS_PER_PAGE = this.propPaginationPerPage;

    window.addEventListener('beforeunload', () => {
      if (this.gActiveCriteria) {
        sessionStorage.setItem('selectedCritera', JSON.stringify(this.selectedCritera));
        sessionStorage.setItem('activeCritera', JSON.stringify(this.gActiveCriteria));
        sessionStorage.setItem('selectedScreener', JSON.stringify(this.selectedScreener));
      }
    });

    window.addEventListener('resize', () => {
      this.resizeTable();
    });
  },
  async mounted() {

    let screenTypes = { 
      'equity' : { text: "Equities", value: "equity" },
      'etf' : { text: "ETFs", value: "etf" },
      'mutual_fund' : { text: "Mutual Funds", value: "mutual_fund" }
    }

    let enabledTypes = this.propEnabledTypes.toLowerCase().split(',');

    enabledTypes.forEach(type => {
      this.screenerTypes.push(screenTypes[type]);
    });

    if (this.loadState.instrument) {
      this.selectedScreener = this.loadState.instrument;
    } else {
    
      let sessionselectedScreener = sessionStorage.getItem('selectedScreener');
      if (sessionselectedScreener) {
        sessionselectedScreener = JSON.parse(sessionselectedScreener);
        this.selectedScreener = sessionselectedScreener;
      }
      else {
        this.selectedScreener = this.screenerTypes[0].value;
      }
    }
    
    this.$store.commit("MarketScreener/SET_CURRENT_SCREENER", this.selectedScreener);

    this.showCritera = !this.propAutoCollapse;
    this.authTOken3 = await this.$qModCore.validateTool(
      "MarketScreener",
      this.$store.state.WMID,
      this.$store.state.ENV
    );



    this.$store.commit("MarketScreener/SET_COMPONENT_TOKEN", this.authTOken3);

    await this.$store.dispatch("validateSID");

    this.isLoggedIn = this.$store.state.IS_LOGGEDIN ;

    // await this.$store.dispatch("MarketScreener/setView");
    if (this.isLoggedIn) {
      await this.$store.dispatch("MarketScreener/getViews");
    }
    

    this.$store.commit("MarketScreener/SET_LANG", this.$i18n.locale);

  
    //
    this.$store.commit("MarketScreener/SET_CURRENT_COUNTRY", this.propCountry);
    // await this.$store.dispatch("MarketScreener/getSectors");
    await this.$store.dispatch("MarketScreener/getEquityCriteria");

    this.fixedFilters = Object.assign(this.fixedFilters, this.gfixedFilters);
    this.showtable = true; 
    this.$watch(
      "$i18n.locale",
      async (newLocale, oldLocale) => {
        if (newLocale === oldLocale) {
          return;
        }
        this.$store.commit("MarketScreener/SET_LANG", newLocale);
        //
        // await this.$store.dispatch("MarketScreener/getSectors");
        await this.$store.dispatch("MarketScreener/getEquityCriteria");

        if (this.subScreenerCriteria) {
            this.subScreenerCriteria = this.gEquityCriteria.find(
                (crt) => crt.id == this.subScreenerCriteria
            ).id;
        }
        let oldCrit = this.selectedCritera;
        let newCrit = [];

        oldCrit.forEach((option) => {
          let idToMatch = option.id;
          this.gEquityCriteria.every((filter) => {
            let match = filter.fixedFilters.find((x) => x.id == idToMatch);
            if (!match) {
              match = filter.rangedFilters.find((x) => x.id == idToMatch);
            }
            if (match) {
              newCrit.push(match);
              return false;
            }
            return true;
          });
        });
        this.selectedCritera = [];
        this.selectedCritera = newCrit;
      },
      { immediate: false }
    );

    let sessionActiveCriteria = sessionStorage.getItem('activeCritera');

    if (useDefaultLoadState(this.loadState, sessionActiveCriteria)) {
      this.$store.commit("MarketScreener/SET_ACTIVE_CRITERIA_FROM_PARAM", this.loadState.criteria);
      
      await this.$store.dispatch("MarketScreener/getEquityCriteria");
      
      this.selectedCritera = [];
      this.setSubCriteria(0);
    } else if (sessionActiveCriteria) {
      sessionActiveCriteria = JSON.parse(sessionActiveCriteria);

      if (sessionActiveCriteria.length > 0) {
        this.$store.commit("MarketScreener/SET_ACTIVE_CRITERIA_FROM_SESSION", sessionActiveCriteria);
        this.setSubCriteria(0);
        this.selectedCritera = JSON.parse( sessionStorage.getItem('selectedCritera'));
        await this.$store.dispatch("MarketScreener/getFilteredResults");
      } else { // no session criteria, so set the default criteria as the first one
        this.setSubCriteria(0);
      }
    } else {
      this.setSubCriteria(0);
    }

    this.resizeTable();

    this.$store.metrics.add(this.$options.name, "loaded", this.$props, this.qmWMID);
  },
  computed: {
    currentTab: {
      set: function(val) {
        //CURRENT_TAB
        this.$store.state.MarketScreener.CURRENT_TAB = val;
      },
      get: function() {
        return this.$store.state.MarketScreener.CURRENT_TAB
      }
    },

    currentPage: {
        set: function(val) {
            this.$store.state.MarketScreener.CURRENT_PAGE = val;
        },
        get: function(){
            return this.$store.state.MarketScreener.CURRENT_PAGE;
        }
    },

    selectedCritera() {
      return this.$store.state.MarketScreener.SELECTED_CRITERA;
    },
    
    console: () => console,
    ...mapState("MarketScreenr", ["ACTIVE_CRITERIA", "IS_LOADING"]),
    ...mapGetters("MarketScreener", [
      "gCustomTabItems",
      "gTabItems",
      "gEquityCriteria",
      "gfixedFilters",
      "gActiveCriteria",
      "gATotalFiltered",
      "gAvailableCountrys",
      "gResults",
      "gATotalResults",
      "gLoading",
      "gSectorSelected",
      "gSectorSelectedLabels",
      "gExport",
        "gSearchCritera",
        "gSectorList",
        "gSortTable",
        "gSymbolList"
    ]),
    getFixedFilters: function() {
      return this.gfixedFilters;
    },
    getscreenerCriteria: function() {
      return this.screenerCriteria;
    },
    getResultsHeader: function() {
      if (this.gResults.length) {
        return Object.keys(this.gResults[0]).splice(0, 10);
      }
      return [];
    },
    gFullPages() {
      return this.$store.state.MarketScreener.SYMBOL_LIST.length < this.propPaginationPerPage
        ? 1
        : Math.ceil(this.$store.state.MarketScreener.SYMBOL_LIST.length / this.propPaginationPerPage);
    },
  },

  methods: {
    autoCompleteBlur() {
      this.$refs.symbolautocomplete.isMenuActive = false;
    },
    tabClicked() {

      setTimeout(() => {
        this.resizeTable();
      }, 100);

    },
    toggleChildRow(row) {
      this.$set(row, 'areChildrenVisible', !row.areChildrenVisible)
    },
    resizeTable() {
      const WRAPPER = this.$refs.tableWrapper;
      const TABLEREF = this.$refs['tableElement-' + this.currentTab];
      const TABLE = TABLEREF && TABLEREF[0];
      if (!TABLE) return;

      let tWidth = TABLE.clientWidth;
      let wWidth = WRAPPER.clientWidth;

      let currentTabTable = this.gTabItems.filter(x => x.label == this.currentTab);

      let tableItems = currentTabTable[0].table.items.findIndex(x => x.visible == false); //currentTabTable[0].table.items.length-1;

      tableItems = tableItems > 0 ? tableItems-1 : currentTabTable[0].table.items.length-1;

      while (tWidth > wWidth) {
        let cacledTdWdith = TABLE.children[0].children[tableItems].clientWidth; // - 75;
        currentTabTable[0].table.items[tableItems].visible = false;
        currentTabTable[0].table.items[tableItems].cacledTdWdith = cacledTdWdith;
        currentTabTable[0].table.items[tableItems].hiddenAt = tWidth;
        currentTabTable[0].hasChildren = true;
        
        tWidth -= cacledTdWdith;
        tableItems -= 1;
      }

      if (wWidth >= tWidth) {
        let lastVisibleTD = currentTabTable[0].table.items.find(x => x.visible == false);
        let lastVisibleTDidx = currentTabTable[0].table.items.findIndex(x => x.visible == false);
        if (!lastVisibleTD) return;
        let cacledTdWdith = lastVisibleTD.hiddenAt;
        if ( cacledTdWdith <= wWidth) {
          lastVisibleTD.visible = true;
          if (lastVisibleTDidx == currentTabTable[0].table.items.length-1) {
            currentTabTable[0].hasChildren = false;
          }
        }
      }
    },
    async addSymbolLookup_input() {
      await this.$store.dispatch("MarketScreener/getFundFilteredResults");
    },
    addSymbolLookup_change() {
    },
    async addSymbolLookup (symbol) {
      this.criteraforLookup.selected.push(symbol)
      this.symbollookup = false;
      await this.$store.dispatch("MarketScreener/getFundFilteredResults");
    },
    addSymbolLookup_open (crit, event) {
      if (event.target.tagName == 'INPUT') {
        this.criteraforLookup = crit;
        setTimeout(() => {
          this.symbollookup = true;
        }, 250);

      }
    },
    addSymbolLookup_close () {
      this.symbollookup = false;
    },
    actionMenuHandler (item) {
      let eventInfo = {};
      if (item.info.symbol) { // ETF or Fund
        eventInfo.symbol =  item.info.symbol;
        eventInfo.datatype =  item.info.instrumentType;
      }
      else {
        eventInfo.symbol = item.info.companyBasics.symbol;
        eventInfo.datatype = 'equity';
      }
      item.info = eventInfo;
      window[this.propActionMenu.actionMenuHandler](item);
    },
    async setDate(event, reference, key, menuToClose) {
      let result = new Date(event).getTime();
      reference[key] = result;
      await this.$store.dispatch("MarketScreener/getFilteredResults");
      this[menuToClose] = false;
    },
    formatDate(date) {
      if (!date) return null
      date = parseInt(date);
      const [year, month, day] = new Date(date).toISOString().substr(0, 10).split('-');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    convertDate(date) {
      date = parseInt(date);
      return new Date(date).toISOString().substr(0, 10);
    },
    async sortTable(sortTableitem) {
      this.$store.commit('MarketScreener/SET_SORT_TABLE', sortTableitem);
      // await this.$store.dispatch("MarketScreener/getFilteredResults");

    },
    getSectorByType(type) {
      let sector = this.gSectorList.filter(item => {
        let fixedSector = Number(String(type).substring(0, 3))
        return item.type == fixedSector; //.substring(0, 3)
      })
      return sector[0] ? sector[0].label.replace('--', '') : '';
    },
    getSectorByType2(type) {
      let sector = this.gSectorList.filter(item => {
        // console.log('item', item);
        // console.log('type', type);
        return item.type == type;
      })
      return sector[0] ? sector[0].label.replace('--', '') : '';
    },
    tabChanged() {
    },
      changeSelected(changed) {
        const match = this.gActiveCriteria.find(item => item.id === changed.id);

        if (match) {
          let index = this.gActiveCriteria.indexOf(match);
          this.delFilter(index, match)
          return;
        }

        let update = changed;
        this.$store.commit('MarketScreener/SET_SELECTED_CRITERA', update);
      },
      getSectorNameByCode(code) {
          let sector = this.gSectorList.find((x) => x.type == code);
          return sector;
      },
      doSearchLookup(item) {
        console.debug('doSearchLookup', item);
        this.subScreenerCriteria =  this.selectedScreener == 'equity' ? item.parentID : item.parentID -1;
        const scrollID = item.id + item.parentID;

        setTimeout(
            () => {
            document.getElementById(scrollID).scrollIntoView();
        }, 250, scrollID);

      },
    isParentSector(child, idx) {
      if (this.gSectorSelected.find((x) => x == child.parent)) {
        return ``;
      } else {
          let secName = this.getSectorNameByCode((child.type));
        if (this.gSectorSelected.length > 1) {
          if (idx === 0) {
            return `${secName.label}`;
          } else {
            return `, ${secName.label}`;
          }
        } else {
          return `${secName.label}`;
        }
      }
    },
    checkboxClick(event) {
      event.target.children[0].children[0].children[0].children[0].children[1].click();
    },
    isPosNeg(value) {
      let testvalue = Math.sign(value);
      let classtoAdd;
      if (testvalue >= 1) {
        classtoAdd = "qmod-up";
      } else if (testvalue == 0) {
        classtoAdd = "";
      } else {
        classtoAdd = "qmod-down";
      }

      return classtoAdd;
    },
    downloadCSV(csv, filename) {
      var csvFile;
      var downloadLink;

      csvFile = new Blob([csv], { type: "text/csv" });
      downloadLink = document.createElement("a");
      downloadLink.download = filename;
      downloadLink.href = window.URL.createObjectURL(csvFile);
      downloadLink.style.display = "none";
      document.body.appendChild(downloadLink);
      downloadLink.click();
    },
    async exportTableToCSV(filename) {

      if (this.propExportAsEvent) {
        const event = new CustomEvent('QMODII', { 
          detail: {
            tool: 'MarketScreener',
            type: 'export',
            data: this.gSymbolList.join(',')
          } 
        })
        document.dispatchEvent(event);
        return;
      }


      // var evt = new CustomEvent("QMOD:LOADER:FINISHED");
      // window.dispatchEvent(evt);
      //gCustomTabItems
      //gTabItems

      var tabField = this.gTabItems.filter(tab => {
        return tab.label === this.$store.state.MarketScreener.CURRENT_TAB
      })

      if (!tabField.length) {
        tabField = this.gCustomTabItems.filter(tab => {
          return tab.label === this.$store.state.MarketScreener.CURRENT_TAB
        })
      }


      let nItem = tabField[0].items? tabField[0].items : tabField[0].table.items;
      const fields = [
      ];

      nItem.forEach(item => {

       if (item.label === 'Sector') {
        fields.push({
          label: item.label,
          value: 'companyBasics.Sectorname'
        }) 
      }
      else if (item.label === 'Industry') {
        fields.push({
          label: item.label,
          value: 'companyBasics.Industryname'
        })
      }
      else {
        fields.push({
          label: item.label,
          value: item.key
        })
      }

      });


      const json2csvParser = new Parser({ fields });

      await this.$store.dispatch('MarketScreener/getQuoteForExport');

      this.gExport.forEach((value) => {
        if (value.companyBasics) {
          let mutate = value.companyBasics.sector;
          value.companyBasics.Sectorname = mutate ? this.getSectorByType(mutate) : 'none';
          value.companyBasics.Industryname = mutate ? this.getSectorByType2(mutate) : 'none';
        }
      });

      const csv = json2csvParser.parse(this.gExport);
      this.downloadCSV(csv, filename);
    },
    addcriteralist(ctoadd) {
      if (this.selectedCritera.indexOf(ctoadd) === -1) {
        this.selectedCritera.push(ctoadd);

      } else {

        // this.selectedCritera.splice(this.selectedCritera.indexOf(ctoadd), 1);
      }
      // this.selectedCritera.push(ctoadd);
    },

    async changeCountry(country) {
      this.subScreenerCriteria = null;
      let humanCountry = country == 0 ? "US" : "CA";
      this.$store.commit("MarketScreener/CLEAR_ALL");
      this.$store.commit("MarketScreener/SET_CURRENT_COUNTRY", humanCountry);
      // await this.$store.dispatch("MarketScreener/getExchanges");
      this.selectedCritera = [];
      this.subScreenerCriteria = 0;
      await this.$store.dispatch(
        "MarketScreener/getEquityCriteria",
        humanCountry
      );

    },
    async changeScreener() {
      this.$store.commit("MarketScreener/CLEAR_ALL");
      this.selectedCritera.splice(0, this.selectedCritera.length);
      this.subScreenerCriteria = false;

      await this.$store.dispatch(
        "MarketScreener/changeScreener",
        this.selectedScreener
      );

      this.setSubCriteria(0);
    },
    fixNumber(num, fixed) {
      if (num === null) {
        return null;
      } // terminate early
      if (num === 0) {
        return "0";
      } // terminate early
      num = parseFloat(num);
      fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
      var b = num.toPrecision(2).split("e"), // get power
        k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
        c =
          k < 1
            ? num.toFixed(0 + fixed)
            : (num / Math.pow(10, k * 3)).toFixed(1 + fixed), // divide by power
        d = c < 0 ? c : Math.abs(c), // enforce -0 is 0

        e = this.formatNumberComma(d) + ["", "K", "M", "B", "T"][k]; // append power)
      return e;
    },
    testnumber(abc) {
      return this.fixNumber(abc, 2);
    },
    convertNumber(event, reference, key) {
      let num = event.target.value.toLowerCase();
      let multiplier = 0;
      let result = 0;
      if (num.includes("k")) {
        multiplier = 1000;
      } else if (num.includes("m")) {
        multiplier = 1000000;
      } else if (num.includes("b")) {
        multiplier = 1000000000;
      } else if (num.includes("t")) {
          multiplier = 1000000000000;
      }

      if (!num) num = 0;

      result = multiplier ? parseFloat(num) * multiplier : parseFloat(num);

      if (parseFloat(reference[key]) == result) return;

      if (key == "minRange") {
        document.getElementById(reference.id).noUiSlider.set([result], true,true);
      }

      else {
        document.getElementById(reference.id).noUiSlider.set([null, result], true,true);
      }

      if (key === 'minRange') {

        if (result < Number(reference.histogram.steps[0])) {

            reference.showErrorMin = [this.$t("msgs.min_to_low")] //
        }
        else if (result > Number(reference.histogram.steps[reference.histogram.steps.length-1])) {
            reference.showErrorMin = [this.$t("msgs.max_to_low")]
        }
        else {
            reference.showErrorMin = []
        }

      }
      else {
          if (result > Number(reference.histogram.steps[reference.histogram.steps.length-1])) {
              reference.showErrorMax = [this.$t("msgs.max_to_low")]
          }
          else if (result < Number(reference.histogram.steps[0])) {
              reference.showErrorMax = [this.$t("msgs.min_to_low")]
          }
          else {
              reference.showErrorMax =  []
          }

      }

      reference[key] = result;
    },
    async changePage() {
      await this.$store.dispatch(
        "MarketScreener/getFundByPage",
        this.currentPage
      );
      this.resizeTable();
    },
    closemodals() {
      this.modal2 = false;
    },
    openmodal(type, tab) {
      if (type == "preset") {
        this.modaltype = "Screens";
      } else if (type == "sector") {
        this.modaltype = "Sectors";
      } else if (type == "custom") {
        this.modaltype = "customModal";
      }else {
        this.modaltype = "SavedScreens";
        this.opentab = tab;
      }
      setTimeout(() => {
        this.modal2 = true;
      }, 250);
    },
    async selectChange(critera) {
      await this.$store.dispatch("MarketScreener/getFilteredResults");
      if (critera) {
        await this.$store.dispatch("MarketScreener/getEquityPreviewCount", critera);
      }
    },

    async selectChangeFund(critera) {
        await this.$store.dispatch("MarketScreener/getFundFilteredResults");
        if (critera) {
            await this.$store.dispatch("MarketScreener/getFundPreviewCount", critera);
        }
    },

    async saveCurrentScreen() {
      this.savingscreens = true;
      let screentosave = this.gActiveCriteria.map((screen) => {
        let rturn = {
          alias: screen.id,
          min: screen.minRange,
          max: screen.maxRange,
        };
        return rturn;
      });

      await axios.post(
        `//${
          this.$store.state.ENV
        }.quotemedia.com/screener/screens/saved/datatool/type/equity?wmid=${
          this.$store.state.WMID
        }&token=${this.$store.state.MarketScreener.componentToken}${
          this.$store.state.SID ? "&sid=" + this.$store.state.SID : ""
        }`,
        {
          name: this.savescreenername,
          settings: JSON.stringify(screentosave),
        },
        { withCredentials: true }
      );

      this.savingscreens = false;

      this.modal3 = false;
    },
    SaveScreen() {
      this.modal3 = !this.modal3;
    },
    formatInstrumentType(value) {
      if (value == 'mutualfund') return 'mutual fund';
      if (value == 'etf') return 'ETF';
      return value;
    },
    formatSymbolFoward(value) {
      if (this.symbolforwardURL) {
        try {
          let SFURL = new URL(this.symbolforwardURL)
          SFURL.searchParams.set('symbol', value);
          SFURL.searchParams.set('datatype', this.selectedScreener)
          return `<a class="qmodii-link qmodii-symbolfoward" target="_blank" href="${SFURL.toString()}">${value}</a>`
        }
        catch {
          return `<a class="qmodii-link qmodii-symbolfoward" target="_blank" href="${this.symbolforwardURL}${value}&datatype=${this.selectedScreener}">${value}</a>`
        }

      }
      return value;
    },
    formatLongnameFoward(value) {
      if (this.forwardURL) {
        try {
          let SFURL = new URL(this.forwardURL)
          SFURL.searchParams.set('longname', value)
          SFURL.searchParams.set('datatype', this.selectedScreener)
          return `<a class="qmodii-link qmodii-symbolfoward" target="_blank" href="${SFURL.toString()}">${value.length > 60 ? value.slice(0,60) + '...' : value}</a>`
        }
        catch {
          return `<a class="qmodii-link qmodii-symbolfoward" target="_blank" href="${this.forwardURL}${value}&datatype=${this.selectedScreener}">${value.length > 60 ? value.slice(0,60) + '...' : value}</a>`
        }
      }
      return `<span class="qmodii-longname qmodii-turncade" aria-label="${value}">${value.length > 60 ? value.slice(0,60) + '...' : value}</span>`
    },
    formatNumberComma(value2) {
      let locale = this.$i18n.locale == "fr" ? "fr-CA" : undefined;
      if (!value2 || value2=='-') return "-";
      return Number(value2).toLocaleString(locale, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
    },
    formatNumberCommaNoDec(value2) {
      let locale = this.$i18n.locale == "fr" ? "fr-CA" : undefined;
      if (!value2|| value2=='-') return "-";
      return value2.toLocaleString(locale, {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });
    },
    formatNumber(value) {
      let num = value;

      if (num >= 1000000000) {
        return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "B";
      }
      if (num >= 1000000) {
        return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
      }
      if (num >= 1000) {
        return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
      }
      return num;
    },
    genChartURL(symbolString) {
      let URL = "//app.quotemedia.com/datatool/getEnhancedQuotes.json?";
      return (
        URL +
        "&token=" +
        this.authTOken3 +
        "&limit=1500&&symbols=" +
        symbolString
      );
      // })
    },
    changeDropdown(dd, index) {
      dd.dropdown.selected = index;
      dd.dropdown.open = !dd.dropdown.open;
    },
    openDropdown(dd) {
      dd.dropdown.open = !dd.dropdown.open;
    },
    setSubCriteria: function(subCriteria) {
      this.subScreenerCriteria = subCriteria;
    },
    setactiveCriteria: function(activeCriteria) {
      this.activeCriteria = activeCriteria;
    },
    async delFilter(idx, critera) {

      this.$store.commit("MarketScreener/REMOVE_ACTIVE_CRITERIA_BY_INDEX", idx);
      await this.$store.dispatch("MarketScreener/getFilteredResults");
      this.$store.commit('MarketScreener/SET_SELECTED_CRITERA', critera);
      // this.selectedCritera = this.selectedCritera.filter(
      //   (data) => data.id != critera.id
      // );
      // this.zfilters.splice(idx, 1)
    },
    async addSignleFilter() {
      if (this.mobileSelected == 'default' || this.mobileSelected == '') return;
      if (this.selectedScreener==='mutual_fund' || this.selectedScreener==='etf') {
        await this.$store.dispatch(
            "MarketScreener/getFundPreviewRange",
            this.mobileSelected
        );
      }
      else {
        await this.$store.dispatch(
          "MarketScreener/getequityPreviewRange",
          this.mobileSelected
        );
      }

      await this.$store.dispatch("MarketScreener/getFilteredResults");
    },
    async addFilter() {
      this.currentPage = 1;

      if (this.selectedScreener==='mutual_fund' || this.selectedScreener==='etf') {
          let comborequest = this.selectedCritera.map(async (element) => {
       
              await this.$store.dispatch(
                  "MarketScreener/getFundPreviewRange",
                  element
              );
    
          });

          await Promise.all(comborequest);
      }
      else {
          let comborequest = this.selectedCritera.map(async (element) => {
              await this.$store.dispatch(
                  "MarketScreener/getequityPreviewRange",
                  element
              );
          });

          await Promise.all(comborequest);

          await this.$store.dispatch("MarketScreener/getFilteredResults");

          // document
          //     .getElementsByClassName("qmod-selectedcriteria")[0]
          //     .scrollIntoView();
      }

      this.resizeTable();


    },

    async updateActiveRanges() {
      await this.$store.dispatch("MarketScreener/getequityPreviewRange");
    },
    getPropByPath (object, path, defaultValue)  {
      const _path = Array.isArray(path)
          ? path
          : path.split('.');
      if (object && _path.length) return this.getPropByPath(object[_path.shift()], _path, defaultValue);
      return object === undefined ? defaultValue : object;
    },
    getColValue(object, path, defaultValue, format) {
      let returnValue = this.getPropByPath(object, path, defaultValue);
      if (returnValue === '-' || format === '') return returnValue;

      if (format === 'html') {
        if (path === 'commissionFree') {
          if (object['commissionFree'] == true) {
            returnValue = `<span class="commissionFree">Commission-Free</span>`
          } else {
            returnValue = ``
          }
        } else if (path === 'hisaFund') {
          if (object['hisaFund'] == true) {
            returnValue = `<span class="hisaFund">HISA Fund</span>`
          } else {
            returnValue = ``
          }
        }
      }
      else {
        returnValue = this[format](returnValue);
      }

      //fundName
      return returnValue;
    }
  },
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      datemenu: false,
      datemenu2: false,
      opentab: null,
      selectedSectors: [],
      showCritera: true,
      mobileSelected: 'default',
      savingscreens: false,
      isLoggedIn: false,
      modaltype: "",
      savescreenername: "",
      modal3: false,
      modal2: false,
      symbollookup: false,
      criteraforLookup: null,
      tabs: this.$t("tabs.overview"),
      authTOken3: null,
      showtable: false,
      screenerCriteria: null,
      subScreenerCriteria: false,
      activeCriteria: false,
      zfilters: [],
      criteriaResults: [],
      fixedFilters: [],
      selectedScreener: "",
      screenerTypes: [
      ],
      actionMenu: {
        handler: 'click',
        list: [

        ]
      }
      
    };
  },
  components: {
    SymbolLookup,
    VPagination,
    RangeChart,
    VContainer,
    VBtn,
    VSelect,
    VTab,
    VTabs,
    VTabsItems,
    VTabItem,
    VLayout,
    VFlex,
    VSpacer,
    VDialog,
    BaseWrapper,
    BaseBlock,
    // BaseButton,
    BaseDropdown,
    VTextField,
    VRangeSlider,
    Screens,
    Sectors,
    SavedScreens,
    ActionMenu,
    customModal,
    VProgressLinear,
    VCheckbox,
      VAutocomplete,
      VDataTable,
      VMenu,
      VIcon,
      VDatePicker 
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.qmod-crdesc
  pointer-events none
.qmod-up
  color green
.qmod-down
  color red
.qmod-side-btns
  margin-left auto
.qmod-criera-range
  position relative
.qmod-fixed-fixedFilters
  display flex
  width 100%
.qmod-screener-type
  padding-right 10px
.qmod-screener-results
  width 100%
  .v-tabs,
  .v-window
    overflow-y auto
.qmod-truncade
  max-width 210px
  overflow hidden
  text-overflow ellipsis
.qmod-table-numberOfElements
  white-space nowrap
.qmod-table-totalElements
  font-size 10px
.qmod-table
  width 100%
  text-align left
  text-transform capitalize
  font-size 14px
  border-collapse collapse
  .qmodii-dropdownbox
    max-width 470px
    width 470px
  .qmodii-child-toggle
    width 75px;
  .v-messages__message
    text-transform none
    white-space: normal;
  span.qmod-criera-buttons
    display inline-flex
    .qmod-btn
      padding 2px
      .qmod-btn-text
        display inline-flex
  .rangebox
    width 400px
  .qmod-textr
    text-align right
  .qmod-textc
    text-align center
  .qmodii-actions
    text-align center
  tr
    border-bottom 1px solid #ccc
    &:hover
      background transparent
    td, th
      white-space nowrap
      padding 8px 10px
      border-bottom 1px solid #666
      &.qmod-criera-title
        white-space normal;
    th
      text-transform capitalize
      cursor pointer
      &.qmod-textr
        .qmodii-table-header-wrap
           justify-content: flex-end;
      .qmodii-table-header-wrap
        display: inline-flex;
        align-content: flex-end;
        align-items: center;
        width: 100%;
  .qmodii-child-table-open 
    border-bottom 1px solid transparent;
    > td
      border-bottom 1px solid transparent;
  .qmodii-child-table
    border-collapse collapse
    width 100%;
    td
      border-bottom 1px solid transparent;
.qmod-cri-buttons
  display flex
  > button
    margin-left auto

.v-pagination__item:focus
    outline 1px solid black;
.qmod-flex
  display flex
  flex-direction column
  .qmod-screener-title
    font-size 16px
  .qmod-criteria-pick
    // margin 5px
    font-size 14px
    padding 8px 10px
    &.qmod-main-critera
      padding-left 0
      max-width 300px
      min-width 300px
    .qmod-cri-buttons
      margin-top 10px
  .qmod-criteria-desc
    flex 2
  &.qmod-fxrow
    flex-direction row
.qmod-export-tab
  margin-left auto
  cursor pointer
  &:hover
    color #1976d2
  + .qmod-export-tab
    margin-left 5px
    margin-right 2px
.qmod-criter-collpase
  button
    left -5px
    margin-left 0
    padding-left 0
.qmod-parencriteria
  width 100%
  border-bottom 1px solid #ccc
.qmod-table-totalElements
  white-space nowrap
.qmod-results-showing span
  flex 1
  justify-self center
  display flex
.qmod-selectedcriteria
  display flex
  width 100%
  min-height 200px
  flex-direction column
  .qmod-selectedcriteria-item
    display flex
    padding 8px 10px
    border-bottom 1px solid #ccc
    &.qmod-selectedcriteria-btns
      margin-top auto
      margin-bottom 5px
    > span
      flex 1
      justify-self center
      display flex
      &.qmod-table-extras
        flex 0
        margin-left auto
      &.qmod-fx-0
        flex 0
.qmod-table-totalElements
  white-space normal
.qmod-ul
  margin 0
  padding 0
  list-style-type none
  .qmod-criteria-li
    &.qmod-subcritera-li
      flex-direction column
      align-items start
    cursor pointer
    padding 8px 10px
    display flex
    align-items center
    align-content center
    border-radius 3px
    + .qmod-criteria-li
      margin-top 2px
    &:hover, &.qmod-active-li
      background-color #1976d2
      color #fff
      .qmod-icon
        color #fff
  &.qmod-criteria-ul
    align-self flex-start
    overflow-y auto
    max-height 310px
    border-right 2px solid #ccc
    flex auto
  .qmod-icon
    color #1976d2
  .qmod-criname
    align-content center
    display flex
    align-items center
    padding-left 5px
    > .qmod-crcheckbox
      margin-top 0
      .v-input__slot
        margin-bottom 5px
      .v-messages
        display none
.commissionFree, .hisaFund 
  display inline-flex
  border 1px solid #707070
  border-radius 4px
  padding 5px
  text-transform uppercase
.qmod-flag
  margin-right 10px
.qmod-mobile-select
  margin 10px 0
  width 100%
  border-bottom 1px solid black
  -moz-appearance revert
  -webkit-appearance revert
.v-tabs__wrapper 
  overflow visible
  contain none
@media (max-width 670px)
  .qmod-table .qmod-tr0
    border-bottom 0;
  .qmod-table .qmod-tr0 td
    border-bottom 0;
  .qmod-tr1
    td:first-child, th:first-child
      display none
  .v-pagination__more
    display none
  .qmod-selectedcriteria .qmod-selectedcriteria-item
    padding 0;
  .v-pagination__navigation
    margin 0.3rem 1px
  .qmod-selectedcriteria .qmod-selectedcriteria-item span.qmod-table-extras
    flex-direction column
    flex 1
    justify-content: space-between;
  .qmod-selected-critera-table
    tr th
      text-align left
    tr td,
    tr th
      padding 2px;
      font-size 12px
    tr td,
    tr td .v-input
      white-space normal
      font-size 12px
  .qmod-criteria-pickers, .qmod-cri-buttons
    display none
  .qmod-rangechart, .qmod-criera-range
    visibility hidden
    width 0
    display none
@media (min-width 670px)
  .qmod-mobile-critera
    display none
  .qmod-tr0
    display none;
</style>
